export default __webpack_public_path__ + "assets/60ec3be7e7991ea09b3a044f11dfa097.jpg";